import React, { memo } from 'react';
import { HeartHandshakeIcon, MountainIcon, ShieldCheckIcon, UsersIcon } from 'lucide-react';
import { CompanyPageLayout } from '../components/CompanyPageLayout';
const principles = [{
  icon: MountainIcon,
  title: 'Local knowledge, shared openly',
  text: 'Our routes are shaped by people who live close to the trails, seasons, and communities you will meet.'
}, {
  icon: ShieldCheckIcon,
  title: 'Prepared, not over-planned',
  text: 'Clear briefings, measured pacing, and backup thinking leave room for the weather and the unexpected.'
}, {
  icon: UsersIcon,
  title: 'Small groups, real connection',
  text: 'Smaller departures make it easier to move thoughtfully and give each traveller room to find their rhythm.'
}, {
  icon: HeartHandshakeIcon,
  title: 'Travel with reciprocity',
  text: 'We work with local stays and teams, keeping the people behind every journey visible and valued.'
}];
export function WhyChooseUs() {
  return <CompanyPageLayout eyebrow="Why choose us" title="Care is part of every mile." intro="We design Nepal journeys around the details that make travel feel more confident, more connected, and more memorable long after the trail ends." data-id="element-964">
      <section className="px-5 py-20 sm:px-8 sm:py-28 lg:px-12" data-id="element-965">
        <div className="mx-auto max-w-[1180px]" data-id="element-966">
          <div className="grid gap-10 lg:grid-cols-[0.72fr_1.28fr]" data-id="element-967">
            <p className="text-[10px] font-bold uppercase tracking-[0.23em] text-[#4f8057]" data-id="element-968">
              Our approach
            </p>
            <h2 className="max-w-3xl font-serif text-4xl leading-tight sm:text-5xl" data-id="element-969">
              We pay attention before the journey asks you to.
            </h2>
          </div>
          <div className="mt-12 grid gap-px overflow-hidden border border-[#cbd0c2] bg-[#cbd0c2] md:grid-cols-2" data-id="element-970">
            {principles.map(({
            icon: Icon,
            title,
            text
          }) => <article key={title} className="bg-[#f8f5ed] p-7 sm:p-9" data-id="element-971">
                <Icon className="h-7 w-7 text-[#4f8057]" aria-hidden="true" data-id="element-972" />
                <h3 className="mt-7 font-serif text-3xl leading-tight" data-id="element-973">
                  {title}
                </h3>
                <p className="mt-4 max-w-md leading-7 text-[#52635a]" data-id="element-974">{text}</p>
              </article>)}
          </div>
        </div>
      </section>
      <section className="bg-[#e7e7db] px-5 py-16 sm:px-8 lg:px-12" data-id="element-975">
        <div className="mx-auto grid max-w-[1180px] gap-7 md:grid-cols-3" data-id="element-976">
          {[['01', 'Listen first', 'We begin with your pace, interests, and non-negotiables.'], ['02', 'Plan clearly', 'You receive honest detail on route rhythm, conditions, and support.'], ['03', 'Travel lightly', 'On the ground, our local team keeps the experience responsive and grounded.']].map(([number, title, text]) => <article key={number} className="border-t border-[#9eaa9e] pt-5" data-id="element-977">
              <p className="text-[10px] font-bold tracking-[0.2em] text-[#4f8057]" data-id="element-978">
                {number}
              </p>
              <h3 className="mt-4 font-serif text-2xl" data-id="element-979">{title}</h3>
              <p className="mt-3 leading-7 text-[#52635a]" data-id="element-980">{text}</p>
            </article>)}
        </div>
      </section>
    </CompanyPageLayout>;
}